import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import {
  AdditionalDocsApi,
  AdditionalDocsApi_extrareducer,
  SaveHypervergeDataApi,
  SaveHypervergeDataApi_extrareducer,
  GetKycDetailsApi,
  GetKycDetailsApi_extrareducer,
} from './lo-hold/index';

const initialState = {
  isInitialRender: true,
  blockId: 0,
  onScreenComp: [],
  prevBlockId: null,
  prevScreens: [],
  additionalDocsApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  getKycDetailsApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  SaveHypervergeDataApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  addrProofDocSelected: null,
  journeyType: null,
  kycSelectedDoc: null,
  isHypervergeKycLoading: null,
  userInputs: {
    img1: '',
    img2: '',
    imgPath1: '',
    imgPath2: '',
    forcePush1: 1,
    forcePush2: 1,
    idNumber: '',
    idNumberErr: '',
    errMsg1: '',
    errMsg2: '',
    successMsg1: '',
    successMsg2: '',
    expDate: '',
    expErr: '',
  },
};

export const LoHoldSlice = createSlice({
  name: 'loHold',
  initialState,
  reducers: {
    updateInitialRender: (state) => {
      state.isInitialRender = false;
    },
    updateBlockId: (state, action) => {
      const newBlockId = action.payload;
      state.blockId = newBlockId;
    },
    updateOnScreenComp: (state, action) => {
      state.onScreenComp.length = 0; // empty the array
      state.onScreenComp = [...action.payload];
    },
    updatePrevBlockId: (state, action) => {
      const prevBlockId = action.payload;
      state.prevBlockId = prevBlockId;
    },
    updatePrevScreens: (state, action) => {
      state.prevScreens.length = 0;
      state.prevScreens = [...action.payload];
    },
    updateAddrProofDoc: (state, action) => {
      state.addrProofDocSelected = action.payload;
    },
    updateJourneyType: (state, action) => {
      state.journeyType = action.payload;
    },
    updateKycSelectedDoc: (state, action) => {
      state.kycSelectedDoc = action.payload;
    },
    updateHypervergeKycLoading: (state, action) => {
      state.isHypervergeKycLoading = action.payload;
    },
    updateInputs: (state, action) => {
      state.userInputs = { ...state.userInputs, ...action.payload };
    },
    resetInputs: (state) => {
      state.userInputs = {
        img1: '',
        img2: '',
        imgPath1: '',
        imgPath2: '',
        forcePush1: 1,
        forcePush2: 1,
        idNumber: '',
        idNumberErr: '',
        errMsg1: '',
        errMsg2: '',
        successMsg1: '',
        successMsg2: '',
        expDate: '',
        expErr: '',
      };
    },
  },
  extraReducers: {
    ...AdditionalDocsApi_extrareducer,
    ...GetKycDetailsApi_extrareducer,
    ...SaveHypervergeDataApi_extrareducer,
  },
});

export function useLoHoldStore() {
  const additionalDocsApiState = useSelector(
    (state) => state.loHold.additionalDocsApiState
  );
  const SaveHypervergeDataApiState = useSelector(
    (state) => state.loHold.SaveHypervergeDataApiState
  );
  const getKycDetailsApiState = useSelector(
    (state) => state.loHold.getKycDetailsApiState
  );
  const isInitialRender = useSelector((state) => state.loHold.isInitialRender);
  const blockId = useSelector((state) => state.loHold.blockId);
  const onScreenComp = useSelector((state) => state.loHold.onScreenComp);
  const prevBlockId = useSelector((state) => state.loHold.prevBlockId);
  const prevScreens = useSelector((state) => state.loHold.prevScreens);
  const addrProofDocSelected = useSelector(
    (state) => state.loHold.addrProofDocSelected
  );
  const journeyType = useSelector((state) => state.loHold.journeyType);
  const kycSelectedDoc = useSelector((state) => state.loHold.kycSelectedDoc);
  const isHypervergeKycLoading = useSelector(
    (state) => state.loHold.isHypervergeKycLoading
  );
  const userInputs = useSelector((state) => state.loHold.userInputs);

  const dispatch = useDispatch();

  return {
    // state
    isInitialRender,
    additionalDocsApiState,
    getKycDetailsApiState,
    SaveHypervergeDataApiState,
    blockId,
    onScreenComp,
    prevBlockId,
    prevScreens,
    addrProofDocSelected,
    journeyType,
    kycSelectedDoc,
    isHypervergeKycLoading,
    userInputs,
    // reducers
    updateInitialRender: () => dispatch(updateInitialRender()),
    updateBlockId: (blockId) => dispatch(updateBlockId(blockId)),
    updateOnScreenComp: (screens) => dispatch(updateOnScreenComp(screens)),
    updatePrevBlockId: (prevBlockId) =>
      dispatch(updatePrevBlockId(prevBlockId)),
    updatePrevScreens: (screens) => dispatch(updatePrevScreens(screens)),
    updateAddrProofDoc: (doc) => dispatch(updateAddrProofDoc(doc)),
    updateJourneyType: (type) => dispatch(updateJourneyType(type)),
    updateKycSelectedDoc: (doc) => dispatch(updateKycSelectedDoc(doc)),
    updateHypervergeKycLoading: (isLoading) =>
      dispatch(updateHypervergeKycLoading(isLoading)),
    updateInputs: (payload) => dispatch(updateInputs(payload)),
    resetInputs: () => dispatch(resetInputs()),
    // api_calls
    AdditionalDocsApi: (payload) => dispatch(AdditionalDocsApi(payload)),
    GetKycDetailsApi: (payload) => dispatch(GetKycDetailsApi(payload)),
    SaveHypervergeDataApi: (payload) =>
      dispatch(SaveHypervergeDataApi(payload)),
  };
}

export const {
  updateInitialRender,
  updateBlockId,
  updateOnScreenComp,
  updatePrevBlockId,
  updatePrevScreens,
  updateAddrProofDoc,
  updateJourneyType,
  updateKycSelectedDoc,
  updateHypervergeKycLoading,
  updateInputs,
  resetInputs,
} = LoHoldSlice.actions;

export default LoHoldSlice.reducer;
